import { EditorialOffer } from '../types/editorial-offer.type';
import { PUBLIC_PRODUCTS_APP_PATHS } from '../../products/constants/public-products-paths.constants';

import occasionalIllustration from '../../assets/img/corbeille-1.png';
import subscriptionIllustration from '../../assets/img/corbeille-3.png';

// Contenu relevé sur la page legacy /corbeille-fruit
// (src/views/Front/Entreprises/CorbeilleFruit.js).
export const FRUIT_BASKET_HERO = {
  title: 'Corbeilles de fruits en entreprise',
  lead: 'Faites profiter vos salariés de fruits frais et 100 % biologiques.',
};

export const FRUIT_BASKET_OFFERS: EditorialOffer[] = [
  {
    illustration: occasionalIllustration,
    illustrationAlt: 'Une corbeille de fruits',
    title: 'Livraison ponctuelle ou occasionnelle',
    subtitle: 'Pour 1 à 3 corbeilles de fruits par livraison',
    ctaLabel: 'Je découvre',
    ctaPath: PUBLIC_PRODUCTS_APP_PATHS.CATALOG_FOR('les-paniers-bio'),
    processTitle: 'Je commande en ligne',
    // Le legacy enferme cette première étape dans le bloc des critères, où elle se lit comme un
    // critère de plus, et relègue les trois suivantes dans un autre bloc. Le parcours est ici
    // reconstitué d'un seul tenant.
    processSteps: [
      "Je choisis mon panier dans l'onglet Corbeille.",
      "Je choisis le jour et l'heure de livraison dans l'onglet Livraison, en sélectionnant l'option à domicile ou en entreprise.",
      'Je crée mon compte. Les informations enregistrées figureront sur la facture : pensez à y indiquer les coordonnées de votre entreprise.',
      'Je paie par carte bleue, et je reçois ma facture par courriel.',
    ],
  },
  {
    illustration: subscriptionIllustration,
    illustrationAlt: 'Plusieurs corbeilles de fruits',
    title: 'Livraison hebdomadaire',
    subtitle: 'Pour plus de 3 corbeilles de fruits par livraison',
    note: 'Nous vous proposons une formule d’abonnement modulable et à la carte.',
    ctaLabel: 'Contactez-nous',
    // Pas de page de contact sous /v2 : le bouton s'affiche sans naviguer.
    ctaPath: null,
    processTitle: 'Je mets en place un abonnement',
    processSteps: [
      'Je choisis avec Bio Culture mon panier et la quantité adaptée à mon besoin.',
      "Je détermine un jour et une heure de livraison.",
      "J'écris à Bio Culture 72 heures à l'avance en cas de changement ou d'interruption.",
      'Bio Culture m’envoie une facture unique en fin de mois, que je règle par chèque ou virement avant le 15 du mois suivant.',
    ],
  },
];

export const FRUIT_BASKET_CONTACT_HINT = 'Et recevez une offre personnalisée';
